module.exports = __webpack_public_path__ + "img/Power-Trip-Logo-booking-app.30192eb4.png";